module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "Add a review of this recipe",
      "subTitle": "Take a picture of the prepared recipe to share with the community"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('recipe-rating', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "read-only": false,
      "count": _vm.recipe.rating.ratingCount,
      "rating": _vm.recipe.rating.userRating,
      "recipe": _vm.recipe
    },
    on: {
      "ratingPicked": _vm.onRatingPicked
    }
  }), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.review),
      expression: "model.review"
    }],
    staticClass: "textAreaReview",
    staticStyle: {
      "min-width": "100%",
      "min-height": "100px",
      "max-width": "100%",
      "margin-bottom": "14px"
    },
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.model.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "review", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isImagesUploading) ? _c('div', [_vm._v("\n        Uploading images...\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.model.images), function(image, index) {
    return _c('img', {
      staticStyle: {
        "height": "50px",
        "border": "1px solid white",
        "margin-bottom": "8px"
      },
      attrs: {
        "index": 'images-' + index,
        "src": image
      }
    })
  }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": 50,
      "tablet": 50,
      "desktop": "50",
      "align": "left"
    }
  }, [_c('multiple-image-uploader', {
    on: {
      "uploading": _vm.onUploading
    },
    model: {
      value: (_vm.model.images),
      callback: function($$v) {
        _vm.$set(_vm.model, "images", $$v)
      },
      expression: "model.images"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": 50,
      "tablet": 50,
      "desktop": 50,
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "primary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving === false ? _vm.$t('message.submitText') : _vm.$t('message.savingText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 2)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-list', {
    staticClass: "reviewList"
  }, _vm._l((_vm.reviews.data), function(item, rindex) {
    return _c('mu-list-item', {
      key: item.user_id,
      attrs: {
        "disableRipple": true
      }
    }, [(!item.user.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n        " + _vm._s(_vm.upperTwoInitials(item.user.display_name)) + "\n      ")]) : _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.user.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(_vm.question.url)
        }
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.user.display_name))]), _vm._v(" "), (!item.isUpdateReviewOpen) ? _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "8px"
      }
    }, [_vm._v(_vm._s(_vm.fromNow(item.createdAt)))]), _vm._v(" "), _vm._l((5), function(ratingI, rindex) {
      return _c('span', {
        key: 'rating-' + rindex,
        class: {
          'activeStar': item.rating.rating >= ratingI
        },
        staticStyle: {
          "color": "rgb(204, 204, 204)"
        }
      }, [_c('mu-icon', {
        attrs: {
          "value": "star"
        }
      })], 1)
    }), _vm._v(" "), (item) ? _c('div', {
      staticStyle: {
        "margin-bottom": "14px",
        "margin-top": "14px",
        "word-break": "normal"
      }
    }, [_c('vue-markdown', {
      attrs: {
        "source": item.review
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((item.images), function(image, iindex) {
      return _c('img', {
        key: 'image-' + iindex,
        staticStyle: {
          "height": "90px"
        },
        attrs: {
          "src": image
        },
        on: {
          "click": function($event) {
            return _vm.openImg(image)
          }
        }
      })
    }), _vm._v(" "), _c('mu-dialog', {
      attrs: {
        "open": _vm.imgModal
      },
      on: {
        "close": _vm.closeImg
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.imgModalSrc
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "slot": "actions",
        "label": "Close"
      },
      on: {
        "click": _vm.closeImg
      },
      slot: "actions"
    })], 1)], 2), _vm._v(" "), _c('mu-list', _vm._l((item.comments), function(comments, cindex) {
      return _c('mu-list-item', {
        key: 'comment-' + cindex
      }, [(!comments.user.profile_large) ? _c('mu-avatar', {
        attrs: {
          "slot": "left",
          "color": "#0179d5",
          "backgroundColor": "#E9E9E8"
        },
        slot: "left"
      }, [_vm._v("\n              " + _vm._s(_vm.upperTwoInitials(comments.user.display_name)) + "\n            ")]) : _c('mu-avatar', {
        attrs: {
          "slot": "left",
          "src": comments.user.profile_large,
          "color": "white",
          "backgroundColor": "#E9E9E8"
        },
        on: {
          "click": function($event) {
            return _vm.goToProfile(_vm.question.url)
          }
        },
        slot: "left"
      }), _vm._v(" "), _c('div', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(comments.user.display_name))]), _vm._v(" "), _c('div', {
        attrs: {
          "slot": "describe"
        },
        slot: "describe"
      }, [_c('div', {
        staticStyle: {
          "margin-bottom": "8px"
        }
      }, [_vm._v(_vm._s(_vm.fromNow(comments.createdAt)))]), _vm._v(" "), _c('span', [_c('vue-markdown', {
        staticStyle: {
          "white-space": "pre-wrap",
          "word-break": "normal"
        },
        attrs: {
          "source": comments.body
        }
      })], 1), _vm._v(" "), (comments.isUpdateCommentOpen) ? _c('span', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editableCommentModel[comments.id]),
          expression: "editableCommentModel[comments.id]"
        }],
        staticClass: "textAreaReview",
        staticStyle: {
          "min-width": "100%",
          "min-height": "100px",
          "max-width": "100%",
          "margin-bottom": "14px"
        },
        attrs: {
          "rows": "4"
        },
        domProps: {
          "value": (_vm.editableCommentModel[comments.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.editableCommentModel, comments.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "reply-block"
      }, [_c('mu-raised-button', {
        attrs: {
          "label": "Cancel"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showUpdateCommentBlock(comments)
          }
        }
      }), _vm._v(" "), _c('mu-raised-button', {
        attrs: {
          "label": "Update",
          "primary": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.updateComment(comments)
          }
        }
      })], 1)]) : _vm._e()]), _vm._v(" "), (comments.userId === _vm.$store.state.user.scope.user_id) ? _c('mu-icon-menu', {
        directives: [{
          name: "tooltop",
          rawName: "v-tooltop.left",
          value: ('Options'),
          expression: "'Options'",
          modifiers: {
            "left": true
          }
        }],
        attrs: {
          "slot": "right",
          "icon": "more_vert"
        },
        slot: "right"
      }, [_c('mu-menu-item', {
        attrs: {
          "title": "Edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editComment(comments)
          }
        }
      }), _vm._v(" "), _c('mu-menu-item', {
        attrs: {
          "title": "Delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteComment(comments.id, item)
          }
        }
      })], 1) : _vm._e()], 1)
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "reply-block"
    }, [_c('mu-raised-button', {
      attrs: {
        "label": !item.isReplyOpen ? _vm.showReply : _vm.hideReply,
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.showReplyBlock(item)
        }
      }
    })], 1), _vm._v(" "), (item.isReplyOpen) ? _c('div', {
      staticClass: "reviewCommentWrap"
    }, [_c('form', [_c('div', {
      staticClass: "reviewComment"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commentModel.body),
        expression: "commentModel.body"
      }],
      staticClass: "textAreaReview",
      staticStyle: {
        "min-width": "100%",
        "min-height": "100px",
        "max-width": "100%",
        "margin-bottom": "14px"
      },
      attrs: {
        "rows": "4"
      },
      domProps: {
        "value": (_vm.commentModel.body)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.commentModel, "body", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('mu-col', {
      attrs: {
        "width": 100,
        "tablet": 100,
        "desktop": 100,
        "align": "right"
      }
    }, [_c('mu-raised-button', {
      attrs: {
        "label": "Submit",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addComment(item)
        }
      }
    })], 1)], 1)])]) : _vm._e()], 2) : _c('div', [_c('div', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editableReviewModel[item.id].review),
        expression: "editableReviewModel[item.id].review"
      }],
      staticClass: "textAreaReview",
      staticStyle: {
        "min-width": "100%",
        "min-height": "100px",
        "max-width": "100%",
        "margin-bottom": "14px"
      },
      attrs: {
        "rows": "4"
      },
      domProps: {
        "value": (_vm.editableReviewModel[item.id].review)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.editableReviewModel[item.id], "review", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.isImagesUploadingForUpdate) ? _c('div', [_vm._v("\n        Uploading images...\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, _vm._l((_vm.model.updateImages), function(image, index) {
      return _c('div', [_c('img', {
        staticStyle: {
          "height": "50px",
          "border": "1px solid white",
          "margin-bottom": "8px"
        },
        attrs: {
          "index": 'images-' + index,
          "src": image
        }
      }), _vm._v(" "), _c('mu-icon', {
        staticStyle: {
          "verticalAlign": "top",
          "cursor": "pointer"
        },
        attrs: {
          "size": "16",
          "value": "close"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.removeImage(item, index)
          }
        }
      })], 1)
    }), 0), _vm._v(" "), _c('mu-row', [_c('mu-col', {
      attrs: {
        "width": 50,
        "tablet": 50,
        "desktop": "50",
        "align": "left"
      }
    }, [_c('multiple-image-uploader', {
      attrs: {
        "existing-images": item.images
      },
      on: {
        "uploading": _vm.onUploadingForUpdate
      },
      model: {
        value: (_vm.model.updateImages),
        callback: function($$v) {
          _vm.$set(_vm.model, "updateImages", $$v)
        },
        expression: "model.updateImages"
      }
    })], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": 50,
        "tablet": 50,
        "desktop": 50,
        "align": "right"
      }
    }, [_c('div', {
      staticClass: "reply-block"
    }, [_c('mu-raised-button', {
      attrs: {
        "label": "Cancel"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.showUpdateReviewBlock(item)
        }
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      attrs: {
        "label": "Update",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.updateReview(item)
        }
      }
    })], 1)])], 1)], 1), _vm._v(" "), (item.user_id === _vm.$store.state.user.scope.user_id) ? _c('mu-icon-menu', {
      directives: [{
        name: "tooltop",
        rawName: "v-tooltop.left",
        value: ('Options'),
        expression: "'Options'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "slot": "right",
        "icon": "more_vert"
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": "Edit"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editReview(item)
        }
      }
    }), _vm._v(" "), _c('mu-menu-item', {
      attrs: {
        "title": "Delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.removeReview(item)
        }
      }
    })], 1) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.reviews.paginationInfo.actualPage < _vm.reviews.paginationInfo.totalPages && _vm.reviews.data.length !== 0) ? _c('mu-card-actions', {
    attrs: {
      "align": "center"
    }
  }, [(!_vm.isAppending) ? _c('div', [_c('mu-raised-button', {
    attrs: {
      "label": "Load more reviews"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getReviews.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAppending) ? _c('div', [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76cedd86","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Components/RecipeReviews.vue
// module id = 3237
// module chunks = 1